// useLoginUserInfo.ts (리덕스로 대체한 훅)
import { useSelector, useDispatch } from 'react-redux';
import {
    setUserInfo,
    setUserMainImageUrl,
    setSelectSiteId,
    setTeacherClassList,
    setUserLogout
} from '../reducers/loginUserInfoReducer';
import {ClassInfo, LoginResponse, provinceInfo, UserInfo} from '../../type/type';


export let SITEID:number = 0;
export function globalSiteIdUpdate(siteId: number) {
    SITEID = siteId;
}
export const useLoginUserInfo = () => {
    const dispatch = useDispatch();
    const { access,
        user,
        userMainImageUrl,
        selectSiteId,
        teacherClassList,
        userClassId,
        classSelectOption } = useSelector((state: any) => state.loginUserInfo);


    // 로그아웃 시 유저 정보 초기화
    const updateLogoutUserInfo = () => {
        dispatch(setUserLogout());
    };

    // 로그인 유저 정보 업데이트 (첫 로그인 시 사용)
    const updateLoginUserInfo = (access: LoginResponse, user: UserInfo, selectSiteId: number) => {
        dispatch(setUserInfo(access, user, selectSiteId));
    };

    // 선택된 사이트 ID 업데이트
    const updateSelectedSite = (siteId: number) => {
        dispatch(setSelectSiteId(siteId));
    };

    // 사용자의 메인 이미지 URL 업데이트
    const updateUserMainImageUrl = (imageUrl: string) => {
        dispatch(setUserMainImageUrl(imageUrl));
    };

    //선생님이 담당하는 반 리스트 업데이트
    const updateTeacherClassList = (teacherClassList: ClassInfo[], userClassId:number, classSelectOption:provinceInfo[]) => {
        dispatch(setTeacherClassList(teacherClassList,userClassId,classSelectOption));
    }


    return {
        access, // 로그인 정보
        user,  // 사용자 정보
        userMainImageUrl,  // 사용자의 메인 이미지 URL (없으면 default 사진)
        selectSiteId, // 선택된 사이트 ID
        teacherClassList, // 선생님이 담당하는 반 리스트
        userClassId, //선생님이 담당하는 default class id
        classSelectOption, //선생님이 담당하는 반 리스트의 select box 옵션
        updateLoginUserInfo,  // 로그인 유저 정보 업데이트
        updateSelectedSite,  // 선택된 사이트 ID 업데이트
        updateUserMainImageUrl,  // 사용자의 메인 이미지 URL 업데이트
        updateTeacherClassList, // 선생님이 담당하는 반 리스트 업데이트
        updateLogoutUserInfo, // 로그아웃 시 useLoginUserInfo 초기화
    };
};
